module.exports = __webpack_public_path__ + "media/images/amenities_icons/free_parking_on_premise-aacd6d4f333b6f39948b90fd51ff98f8.svg";